/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';


export interface CBCRemediationSpecRemediateRegionalCredentials { 
    vlcr_region?: string;
    cloud_provider?: CloudProvidersEnum;
    skip_irr_reconfiguration?: boolean;
}
export namespace CBCRemediationSpecRemediateRegionalCredentials {
}


